import React from 'react';
import { useBeats } from '../../../hooks/useBeats';
import { TranslationChain } from '../TranslationChain';
import { StageLayout } from '../StageLayout';
import { deviations } from '../../../data/tracking';
const BEATS = [700, 2000];

/** The reveal: the plan has to be translated onto the tooth by hand. */
export function Page3Reveal() {
  const beat = useBeats(BEATS);
  return <StageLayout copy={<>
          <h2 className="max-w-[430px] font-headline text-[24px] font-extrabold leading-[1.1] text-white opacity-0-init animate-fade-in-up md:text-[40px]" data-id="element-195" data-mp="hzctwb6oelaj">
            The digital plan still has to reach the tooth.
          </h2>

          <p className={`mt-4 max-w-[380px] font-body text-sm leading-snug text-solventum-primary transition-[opacity,transform] duration-300 ease-out md:text-lg ${beat >= 1 ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-196" data-mp="rybs0ztteyja">
            The attachment is part of that translation.
          </p>

          <div className="mt-6 flex h-4 items-center gap-2.5" data-id="element-197" data-mp="1k343xhzi6xus">
            {beat >= 2 && deviations.map((deviation, index) => <React.Fragment key={deviation.name} data-id="element-198" data-mp="1f39dtgnjycas" data-mpi={index}>
                  {index > 0 && <span className="font-body text-[10px] text-white/20" data-id="element-199" data-mp="1b5ldfy33brbi">
                      ·
                    </span>}
                  <span className="font-body text-[11px] uppercase tracking-[0.2em] text-white/60 opacity-0-init animate-rise-in" style={{
          animationDelay: `${index * 90}ms`
        }} data-id="element-200" data-mp="115kr039xcv33">
                    {deviation.name}
                  </span>
                </React.Fragment>)}
          </div>
        </>} visual={<div className="w-full max-w-[320px]" data-id="element-201" data-mp="ifcs5xd9cqsp">
          <TranslationChain showComparison={beat >= 1} data-id="element-202" data-mp="ie1odxjtbj1l" />
        </div>} data-id="element-194" data-mp="hy2xrrjdvn6j" />;
}